import React, { Component, Fragment } from 'react'
import TopLinks from '../Components/TopLinks'

class TopLinksContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showTopLinks: false,
        }
        this.clickHandler = this.clickHandler.bind(this)
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.clickHandler)
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.clickHandler)
    }

    clickHandler(event) {
        if (
            this.topLinksContainer &&
            !this.topLinksContainer.contains(event.target)
        ) {
            this.state.showTopLinks && this.toggleShowTopLinks()
        }
    }

    toggleShowTopLinks() {
        this.setState({ showTopLinks: !this.state.showTopLinks })
    }

    render() {
        return (
            <Fragment>
                {this.props &&
                    this.props.values &&
                    this.props.values.links &&
                    this.props.values.links.length > 0 && (
                        <div
                            className="top-link"
                            ref={(elem) => (this.topLinksContainer = elem)}
                            onMouseDown={(e) => this.clickHandler(e)}
                        >
                            <TopLinks
                                {...{
                                    ...this.props.values,
                                    showTopLinks: this.state.showTopLinks,
                                    toggleShowTopLinks: () =>
                                        this.toggleShowTopLinks(),
                                }}
                            />
                        </div>
                    )}
            </Fragment>
        )
    }
}

export default TopLinksContainer
